/**
 * Optional type that allows you to omit certain properties from a type
 * and make them optional.
 *
 * @example
 * type User = {
 *   id: string;
 *   name: string;
 *   email: string;
 * };
 *
 * type UserWithoutEmail = Optional<User, 'email'>;
 *
 * const user: UserWithoutEmail = {
 *   id: '1',
 *   name: 'John Doe',
 * };
 */
export type Optional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export enum TimeUnit {
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
}

export const TimeUnitValues = Object.values(TimeUnit);
